export const DEFAULT_BASE_URL = 'https://api.center.dev'
